/**
 * Actualiza un objeto en un array de objetos o lo agrega si no existe
 * @param {Array<object>} arrayObjects - Array de objetos original
 * @param {object} updatedObject - Objeto actualizado
 * @param {string} identifierName - Nombre de la propiedad que identifica el objeto
 * @param {boolean} addToStart - Si es true, cuando se agrega un objeto, lo hace al inicio del array
 * @returns {Array<object>} Array con el objeto actualizado o agregado
 */
export const addOrUpdateObjectInArray = (arrayObjects, updatedObject, identifierName = 'id', addToStart = false) => {
  if (!updatedObject) {
    return arrayObjects
  }

  const existingIndex = arrayObjects.findIndex(object => object[identifierName] === updatedObject[identifierName])

  if (existingIndex !== -1) {
    return arrayObjects.map((object, index) =>
      index === existingIndex ? updatedObject : object
    )
  } else {
    const updatedArray = [...arrayObjects]

    if (addToStart) {
      updatedArray.unshift(updatedObject)
    } else {
      updatedArray.push(updatedObject)
    }

    return updatedArray
  }
}

